import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { UploadsModel } from 'src/app/models/upload/uploads.model';
import { UploadsService } from 'src/app/service/uploads.service';
import { GlobalService } from 'src/app/service/global.service';
import { Subscription } from 'rxjs';
import { extractApiErrorMessage } from '../upload-template.util';

@Component({
  selector: 'app-template-edit',
  templateUrl: './template-edit.component.html',
  styleUrls: ['../upload-edit-layout.css']
})
export class TemplateEditComponent implements OnInit, OnDestroy {

  public uploadsModel = new UploadsModel();
  public uploadsModel1 = new UploadsModel();
  public columnsList: UploadsModel[];
  public selectedUserDoc: UploadsModel[] = [];
  public loggedinUser = '';
  public myTemplateSet = new Set<string>();
  isAccessDisabled = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private route: ActivatedRoute,
    private uploadsService: UploadsService,
    public ete: ExportExcelService,
    private authGaurdService: AuthGaurdService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.isAccessDisabled = this.globalService._permissionCheck('template-view');
    this.loggedinUser = this.authGaurdService.loginUser();
    this.uploadsModel = this.uploadsService.uploadsModel;
    this.myTemplateSet = this.uploadsService.myTemplateSet;
    this.initializeFromContext();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initializeFromContext(): void {
    const params = this.route.snapshot.queryParams;
    const recordName = params['recordname'] || this.uploadsService.uploadsModel?.recordname;

    if (!recordName) {
      this.router.navigate(['/template-view']);
      return;
    }

    this.uploadsModel1.recordname = recordName;

    const cached = this.uploadsService.uploadsModel;
    if (cached?.recordname === recordName) {
      this.applyHeaderFields(cached);
    }

    if (params['recordname'] !== recordName) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { recordname: recordName },
        replaceUrl: true
      });
    }

    this.getColumnsEditList();
  }

  private applyHeaderFields(source: UploadsModel): void {
    this.uploadsModel1.recordname = source.recordname;
    this.uploadsModel1.recorddesc = source.recorddesc;
    this.uploadsModel1.recordtemplate = source.recordtemplate;
  }

  private applyHeaderFromColumnsList(): void {
    if (!this.columnsList?.length) {
      return;
    }
    this.applyHeaderFields(this.columnsList[0]);
  }

  private syncServiceModel(): void {
    this.applyHeaderFields(this.uploadsModel1);
    this.uploadsService.uploadsModel = this.uploadsModel1;
  }

  redirect(url: string): void {
    this.router.navigate(['/' + url]);
  }

  downloadExcelHeaders(): void {
    this.subscriptions.push(
      this.uploadsService.getRecordsList(this.uploadsModel1.recordname).subscribe(
        (response: UploadsModel[]) => {
          this.ete.exportHeaderOnlyTemplate('Template', response);
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  public updateTemplate(): void {
    if (!this.uploadsModel1.recordname) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter record name');
    } else if (!this.uploadsModel1.recordtemplate) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter record template');
    } else {
      for (const updatePlan of this.columnsList) {
        updatePlan.recordname = this.uploadsModel1.recordname;
        updatePlan.recordtemplate = this.uploadsModel1.recordtemplate;
        updatePlan.recorddesc = this.uploadsModel1.recorddesc;
        updatePlan.created_by = this.loggedinUser;
        this.selectedUserDoc.push(updatePlan);
      }
      this.subscriptions.push(
        this.uploadsService.updateTemplate(this.selectedUserDoc).subscribe(
          () => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated successfully');
            this.selectedUserDoc = [];
            this.syncServiceModel();
            this.getColumnsEditList();
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
          }
        )
      );
    }
  }

  public getColumnsEditList(): void {
    this.subscriptions.push(
      this.uploadsService.getColumnsEditList(this.uploadsModel1.recordname).subscribe(
        (res: UploadsModel[]) => {
          this.columnsList = res;
          this.applyHeaderFromColumnsList();
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  trackByColumnIndex(index: number): number {
    return index;
  }
}
